import { useEffect, useState, useRef } from 'react'
import axios from 'axios'

const Data = ({ setAvailableAssets }) => {
  const [assets, setAssets] = useState([])
  const [lastFetchTime, setLastFetchTime] = useState(0)
  const isFetching = useRef(false)

  const fetchAssets = async (retries = 5, delay = 5000) => {
    if (isFetching.current) return;

    const now = Date.now();
    if (now - lastFetchTime < 300000) return;

    isFetching.current = true;
    try {
      const cached = localStorage.getItem('assets');
      if (cached) {
        const parsed = JSON.parse(cached);
        setAssets(parsed);
        setAvailableAssets(parsed);
      }

      for (let i = 0; i < retries; i++) {
        try {
          const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
          console.log('Fetching assets from:', `${apiUrl}/assets`);
          const response = await axios.get(`${apiUrl}/assets`, { timeout: 60000 });
          setAssets(response.data);
          setAvailableAssets(response.data);
          localStorage.setItem('assets', JSON.stringify(response.data));
          setLastFetchTime(now);
          return;
        } catch (error) {
          console.error(`Attempt ${i + 1} failed:`, error.message);
          if (error.response && error.response.status === 429) {
            delay = 10000;
          }
          if (i < retries - 1) {
            await new Promise(resolve => setTimeout(resolve, delay));
          }
        }
      }

      console.warn('All retries failed, using fallback assets');
      const fallbackAssets = [
        { symbol: 'QQQI', price: 44.24, yield: 14.39 },
        { symbol: 'SPYI', price: 44.50, yield: 12.48 },
        { symbol: 'BTCI', price: 52.91, yield: 30.88 },
      ];
      setAssets(fallbackAssets);
      setAvailableAssets(fallbackAssets);
      setLastFetchTime(now);
    } catch (error) {
      console.error('Unexpected error in fetchAssets:', error);
    } finally {
      isFetching.current = false;
    }
  }

  useEffect(() => {
    fetchAssets();
    const interval = setInterval(fetchAssets, 300000);
    return () => clearInterval(interval);
  }, [setAvailableAssets])

  return null;
}

export default Data